import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { fNumber } from '../../utils/formatNumber';

export default function RoleHeader({ roleData, dioceseLevel, handleUserInfo }) {
  return (
    <Box width="100%">
      <Typography variant="h6" sx={{ pr: { xs: 1, sm: 4 }, display: 'flex', justifyContent: 'space-between' }}>
        <Box>{roleData.roleName}</Box>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            textAlign: 'right',
            pr: { xs: 1, sm: 4 },
          }}
        >
          {fNumber(roleData && roleData.users.length)} :
          <Button
            sx={{ pt: 0, pb: 0, color: 'text.secondary' }}
            disabled={!dioceseLevel}
            onClick={() => handleUserInfo(roleData.id)}
          >
            ተጠቃሚ
          </Button>
        </Typography>
      </Typography>
      <Typography
        variant="body"
        sx={{ pl: { xs: 0, sm: 4 }, display: 'flex', justifyContent: 'space-between' }}
        color="text.secondary"
      >
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>{roleData.description}</Box>
      </Typography>
    </Box>
  );
}

RoleHeader.propTypes = {
  roleData: PropTypes.shape({
    roleName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
  }).isRequired,
  dioceseLevel: PropTypes.string.isRequired,
  handleUserInfo: PropTypes.func.isRequired,
};
